import type { RowTabsData } from "~/core";

export const isRowTabs = (row: unknown): row is RowTabsData => {
  return (
    typeof row === "object" &&
    row !== null &&
    "__typename" in row &&
    row.__typename === "row_tabs"
  );
};
